import { Customer } from '~/lib/api/smartsend/types';

export function postcodeHelper(customer: Customer): Customer {
  const output = { ...customer };

  switch (output.CountryIsoCode) {
    case 'GB':
    case 'GBR': {
      try {
        const pattern = /(^\d+[a-zA-Z]?)\s(.*)/;
        const match = pattern.exec(customer.AddressLine1);
        if (match.length === 3) {
          output.AddressLine1 = match[1];
          output.AddressLine2 = match[2];
          output.Locality = customer.AddressLine2;
        }
      } catch {
        // Ignore errors in regex
      }

      output.Postcode = output.Postcode?.replaceAll(' ', '');

      break;
    }
  }

  return output;
}
